<template>
  <div>
    <h3>Seja bem vindo ao Portal do Usuário</h3>
    <p>Que bom vê-lo novamente aqui!</p>
    <form
      ref="loginForm"
      @submit.prevent="onSubmit"
      @keydown.enter.prevent="onSubmit">
      <ErrorAlert :error="error" />
      <div class="form-group">
        <div class="input-group">
          <div class="input-group-prepend">
            <i class="input-group-text ik ik-user" />
          </div>
          <input
            type="email"
            class="form-control"
            ref="email"
            placeholder="Email"
            autocomplete="email"
            v-model="email"
            required>
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <div class="input-group-prepend">
            <i class="input-group-text ik ik-lock" />
          </div>
          <input
            id="password"
            type="password"
            ref="password"
            autocomplete="current-password"
            class="form-control"
            placeholder="Senha de acesso"
            v-model="password"
            required>
          <span class="input-group-append">
            <a
              class="input-group-text"
              href="#"
              @click.prevent="togglePasswordVisibility()">
              <i class="ik ik-eye" />
            </a>
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col text-right">
          <a
            href="#"
            class="recover-password"
            @click.prevent="openForgetPasswordModal">Esqueceu a senha?</a>
        </div>
      </div>
      <div class="sign-btn text-center">
        <button
          type="submit"
          class="btn btn-primary">
          Entrar
        </button>
      </div>
    </form>
    <div class="register">
      <p>
        Sua empresa ainda não usa a API4COM?
        <a
          href="#"
          class="signup-link"
          @click.prevent="goToSignup">
          Criar conta da empresa
        </a>
      </p>
    </div>

    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="forgotPassword"
      ref="forgotPassword"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Fique tranquilo!</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>Informe seus dados para recuperar sua senha!</p>
            <form
              ref="forgotPasswordForm"
              class="forgot-form">
              <ErrorAlert :error="recoverError" />
              <div class="form-group">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <i class="input-group-text ik ik-mail" />
                  </div>
                  <input
                    type="email"
                    class="form-control"
                    ref="recoverEmail"
                    placeholder="Informe seu email"
                    v-model="recoverEmail"
                    @keydown.enter="sendRecoverEmail"
                    required>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal">Esquece, lembrei!</button>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="sendRecoverEmail">Enviar email de recuperação</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="successNotifier"
      ref="successNotifier"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="alert alert-success">{{ successNotifierMessage }}</p>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal">OK</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="errorNotifier"
      ref="errorNotifier"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="alert alert-danger">{{ errorNotifierMessage }}</p>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal">OK</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { executeRecaptcha } from '@/services/recaptcha'

export default {
  name: 'Login',
  data () {
    return {
      email: null,
      password: null,
      error: null,
      recoverError: null,
      recoverEmail: null,
      successNotifierMessage: '',
      errorNotifierMessage: ''
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      this.$refs.email.focus()
      if (this.$route.query && this.$route.query.accessTokenExpired === true) {
        this.error = { message: 'Sua sessão expirou, por favor faça login novamente' }
      }
      if (this.$route.query && this.$route.query.openPasswordRecover === 'true') this.openForgetPasswordModal()
      if (this.$route.query && this.$route.query.emailVerified === 'true') {
        this.successNotifierMessage = 'Parabéns! Seu email foi confirmado com sucesso!'
        $(this.$refs.successNotifier).modal('show')
      }
      if (this.$route.query && this.$route.query.tokenError === 'true') {
        this.errorNotifierMessage = `O link de ativação expirou. Procure pelo email mais recente na sua caixa de entrada e tente novamente. Se o problema continuar, peça ao administrador da sua organização para realizar o desbloqueio do seu email.`
        $(this.$refs.errorNotifier).modal('show')
      }
      if (this.$route.query && this.$route.query.email) {
        this.email = this.$route.query.email.replace(/\s/g, '+')
        this.$refs.password.focus()
      }
    })
  },
  methods: {
    onSubmit () {
      const form = this.$refs.loginForm
      this.error = null
      if (form.checkValidity()) {
        executeRecaptcha('login').then(recaptchaToken => {
          const loginBody = { password: this.password, email: this.email, recaptchaToken }
          this
            .$store
            .dispatch('auth/signIn', loginBody)
            .then(() => {
              this.$router.push(this.$route.query.redirect || {name: 'home'})
            })
            .catch(err => {
              this.parseError(err, errorMessage => {
                this.error = { message: errorMessage }
              })
            })
        })
      } else {
        if (this.email.indexOf('@') === -1) {
          this.error = { message: 'Para fazer o login você precisa informar um email válido' }
        } else {
          this.error = { message: 'Por favor, verifique o email e senha inseridos e tente novamente' }
        }
      }
    },
    sendRecoverEmail () {
      const form = this.$refs.forgotPasswordForm
      this.recoverError = null
      if (form.checkValidity()) {
        executeRecaptcha('reset_password').then(recaptchaToken => {
          this
            .$store
            .dispatch('auth/rememberPassword', { email: this.recoverEmail, recaptchaToken })
            .then(() => {
              $(this.$refs.forgotPassword).modal('hide')
              this.successNotifierMessage = 'Email enviado com sucesso! Por favor, verifique sua caixa de entrada ou spam.'
              $(this.$refs.successNotifier).modal('show')
            })
            .catch((err) => {
              this.parseError(err, errorMessage => {
                this.recoverError = { message: errorMessage }
              })
            })
        })
      } else {
        this.recoverError = {
          message: 'Por favor, verifique o email e senha inseridos e tente novamente'
        }
      }
    },
    goToSignup () {
      this.$router.push({name: 'signup', query: this.$route.query})
    },
    parseError (error, cb) {
      // TEL-2243: mesmo generico do mapa (utils/error-message.js). Telefone em
      // texto, nao com o marcador `{suporte}`: esta string tambem alimenta o modal
      // de recuperacao de senha, e marcador so e resolvido pelo ErrorAlert.
      let errorMessage = 'Não conseguimos processar sua solicitação no momento. Tente novamente em alguns minutos ou fale com o suporte: (48) 3332-8503.'
      if (error) {
        // TEL-2243: no lugar do antigo `errorMessage = error.message` — que jogava o
        // texto em ingles do backend na tela — usa o texto ja traduzido pelo
        // normalizador. `friendly.lines` nunca contem mensagem do backend, e os
        // `if` por `code` abaixo continuam ganhando por virem depois.
        if (error.friendly && Array.isArray(error.friendly.lines) &&
          error.friendly.code !== 'UNKNOWN') {
          errorMessage = error.friendly.lines.join(' ')
        }
        if (error.code === 'EMAIL_NOT_FOUND') errorMessage = 'Não encontramos seu email em nossa base, verifique o email digitado e tente novamente'
        if (error.code === 'LOGIN_FAILED') {
          if (this.email.indexOf('@') === -1) {
            errorMessage = 'Para fazer o login você precisa informar um email válido'
          } else {
            errorMessage = 'Por favor, verifique o email e senha inseridos e tente novamente'
          }
        }
        if (error.code === 'LOGIN_FAILED_EMAIL_NOT_VERIFIED' || error.code === 'RESET_FAILED_EMAIL_NOT_VERIFIED') errorMessage = 'Você ainda não confirmou seu email ou está bloqueado, verifique sua caixa de entrada ou spam e clique no link de confirmação ou entre em contato com um dos Administradores da sua Organização'
        if (['RECAPTCHA_TOKEN_REQUIRED', 'RECAPTCHA_TOKEN_INVALID', 'RECAPTCHA_SCORE_TOO_LOW', 'RECAPTCHA_ACTION_MISMATCH'].includes(error.code)) errorMessage = 'Falha na verificação anti-robô. Recarregue a página e tente novamente.'
      }
      cb(errorMessage)
    },
    openForgetPasswordModal () {
      this.recoverEmail = null
      this.recoverError = null
      $(this.$refs.forgotPassword).on('shown.bs.modal', function () {
        this.querySelector('.forgot-form input[type="email"]').focus()
      }).modal('show')
    },
    togglePasswordVisibility () {
      const input = $('#password')
      if (input[0].type === 'password') {
        input[0].type = 'text'
      } else {
        input[0].type = 'password'
      }
    },
    onModalOk () {
      this.$router.push(this.$route.query.redirect || {name: 'home'})
    }
  },
  watch: {
    email: function (value) {
      this.email = value.replace(/[^A-Za-z0-9|_.@+-]/, '').toLowerCase()
    }
  }
}
</script>

<style lang="scss" scoped>
.recover-password {
  padding: 0;
  background: none;
  border: none;
  box-shadow: none;
  font-size: 13px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}
.register .signup-link {
  background: none;
  border: none;
  padding: 0;
  font-weight: 600;
  color: #007bff;
  text-decoration: underline;

  &:hover {
    color: #0062cc;
    text-decoration: underline;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User/Login.vue